import warningDiamond from '@/assets/images/warning-diamond.webp';

import styles from './dialog.module.scss';

/**
 * The amber warning diamond (exported from Figma `787:679889`) that the confirm dialogs draw in
 * place of `<ConfirmDialog>`'s default trash glyph. Two surfaces ask for it so far: deleting a
 * field from the Map (`113586 §10a`) and cancelling a queued command (Figma `219:343228`).
 *
 * It is a component rather than a bare `<img>` at each call site so the 76×76 geometry the dialog
 * layout reserves lives in one place — `.icon` is the same rule `<ConfirmDialog>`'s own default
 * image uses, which also puts it above `<OverlayPattern>`'s `z-index: 0` texture band.
 */
export function WarningDiamondIcon() {
  return <img src={warningDiamond} alt="" aria-hidden="true" className={styles.icon} />;
}
